import { render } from "./SoldTos.vue?vue&type=template&id=e4bc5b86&scoped=true"
import script from "./SoldTos.vue?vue&type=script&lang=js"
export * from "./SoldTos.vue?vue&type=script&lang=js"

import "./SoldTos.vue?vue&type=style&index=0&id=e4bc5b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4bc5b86"]])

export default __exports__